module.exports = __webpack_public_path__ + "static/media/fast-mail-alt.38b5be45.svg";